module.exports = __webpack_public_path__ + "img/outdoor.727f7345.png";